"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExtsMatching = exports.getExtsForType = exports.getExtsForKind = exports.getExtData = exports.EXT_DATA = void 0;
const types_1 = require("@air/types");
const extData = (ext, type, kind, opts = {}) => {
    return Object.assign({ ext,
        type,
        kind, transcodable: true }, opts);
};
// Helper functions for creating Ext instances
const audio = (ext, opts = {}) => extData(ext, types_1.ClipType.audio, 'audio', opts);
const photo = (ext, opts = {}) => extData(ext, types_1.ClipType.photo, 'image', opts);
const rawPhoto = (ext, opts = {}) => extData(ext, types_1.ClipType.photo, 'image', Object.assign({ mime: 'image/x-dcraw' }, opts));
const animated = (ext, opts = {}) => extData(ext, types_1.ClipType.animated, 'image', opts);
const video = (ext, opts = {}) => extData(ext, types_1.ClipType.video, 'video', opts);
const document = (ext, opts = {}) => extData(ext, types_1.ClipType.photo, 'document', opts);
const nonMedia = (ext, opts = {}) => extData(ext, types_1.ClipType.nonMedia, 'document', Object.assign({ transcodable: false }, opts));
exports.EXT_DATA = {
    // Audio extensions
    wav: audio('wav'),
    m4a: audio('m4a'),
    mp3: audio('mp3'),
    aiff: audio('aiff'),
    aif: audio('aif'),
    ogg: audio('ogg'),
    flac: audio('flac'),
    aac: audio('aac'),
    m4b: audio('m4b'),
    // Raw photo extensions
    '3fr': rawPhoto('3fr'),
    ari: rawPhoto('ari'),
    arw: rawPhoto('arw'),
    bay: rawPhoto('bay'),
    crw: rawPhoto('crw'),
    cr2: rawPhoto('cr2'),
    cr3: rawPhoto('cr3'),
    cap: rawPhoto('cap'),
    data: rawPhoto('data'),
    dcs: rawPhoto('dcs'),
    dcr: rawPhoto('dcr', { transcodable: false }),
    dng: rawPhoto('dng'),
    drf: rawPhoto('drf'),
    eip: rawPhoto('eip', { transcodable: false }),
    erf: rawPhoto('erf'),
    fff: rawPhoto('fff'),
    gpr: rawPhoto('gpr'),
    iiq: rawPhoto('iiq'),
    k25: rawPhoto('k25'),
    kdc: rawPhoto('kdc'),
    mdc: rawPhoto('mdc'),
    mef: rawPhoto('mef'),
    mos: rawPhoto('mos'),
    mrw: rawPhoto('mrw'),
    nef: rawPhoto('nef'),
    nrw: rawPhoto('nrw'),
    obm: rawPhoto('obm'),
    orf: rawPhoto('orf'),
    pef: rawPhoto('pef'),
    ptx: rawPhoto('ptx'),
    pxn: rawPhoto('pxn'),
    r3d: rawPhoto('r3d', { transcodable: false }),
    raf: rawPhoto('raf'),
    raw: rawPhoto('raw', { transcodable: false }),
    rwl: rawPhoto('rwl'),
    rw2: rawPhoto('rw2'),
    rwz: rawPhoto('rwz'),
    sr2: rawPhoto('sr2'),
    srf: rawPhoto('srf'),
    srw: rawPhoto('srw'),
    tif: rawPhoto('tif'),
    tiff: rawPhoto('tiff'),
    x3f: rawPhoto('x3f'),
    // Standard photo extensions
    jpg: photo('jpg'),
    png: photo('png'),
    heic: photo('heic', { mime: 'image/heic' }),
    jpeg: photo('jpeg'),
    svg: photo('svg', { kind: 'vector' }),
    psd: photo('psd'),
    psb: photo('psb'),
    webp: photo('webp'),
    jfif: photo('jfif'),
    avif: photo('avif'),
    ai: photo('ai', { kind: 'vector' }),
    eps: photo('eps', { kind: 'vector' }),
    bmp: photo('bmp'),
    ico: photo('ico'),
    jp2: photo('jp2', { transcodable: false }),
    // Animated extensions
    gif: animated('gif'),
    // Video extensions
    avi: video('avi'),
    flv: video('flv'),
    m2v: video('m2v'),
    m4p: video('m4p'),
    m4v: video('m4v'),
    mkv: video('mkv'),
    mov: video('mov'),
    mp2: video('mp2'),
    mp4: video('mp4'),
    mpeg: video('mpeg'),
    mpg: video('mpg'),
    mxf: video('mxf'),
    mts: video('mts', { mime: 'video/mts' }),
    webm: video('webm'),
    wmv: video('wmv'),
    mpegts: video('mpegts'),
    asf: video('asf'),
    ts: video('ts'),
    m2ts: video('m2ts'),
    qt: video('qt'),
    // Document extensions
    doc: document('doc'),
    docx: document('docx'),
    pdf: document('pdf', { kind: 'pdf' }),
    ppt: document('ppt', { kind: 'presentation' }),
    pptx: document('pptx', { kind: 'presentation' }),
    potx: document('potx', { kind: 'presentation' }),
    key: document('key', { kind: 'presentation' }),
    // Compressed extensions
    zip: nonMedia('zip', { kind: 'compressed' }),
    rar: nonMedia('rar', { kind: 'compressed' }),
    tar: nonMedia('tar', { kind: 'compressed' }),
    gz: nonMedia('gz', { kind: 'compressed' }),
    bz2: nonMedia('bz2', { kind: 'compressed' }),
    '7z': nonMedia('7z', { kind: 'compressed' }),
    iso: nonMedia('iso', { kind: 'compressed' }),
    dmg: nonMedia('dmg', { kind: 'compressed' }),
    pkg: nonMedia('pkg', { kind: 'compressed' }),
    // Spreadsheet extensions
    xls: nonMedia('xls', { kind: 'spreadsheet' }),
    xlsx: nonMedia('xlsx', { kind: 'spreadsheet' }),
    xlsm: nonMedia('xlsm', { kind: 'spreadsheet' }),
    xlsb: nonMedia('xlsb', { kind: 'spreadsheet' }),
    xltx: nonMedia('xltx', { kind: 'spreadsheet' }),
    xltm: nonMedia('xltm', { kind: 'spreadsheet' }),
    xlt: nonMedia('xlt', { kind: 'spreadsheet' }),
    xlam: nonMedia('xlam', { kind: 'spreadsheet' }),
    xlr: nonMedia('xlr', { kind: 'spreadsheet' }),
    xlm: nonMedia('xlm', { kind: 'spreadsheet' }),
    ods: nonMedia('ods', { kind: 'spreadsheet' }),
    // 3D extensions
    stl: nonMedia('stl', { kind: 'threeD' }),
    obj: nonMedia('obj', { kind: 'threeD' }),
    fbx: nonMedia('fbx', { kind: 'threeD' }),
    dae: nonMedia('dae', { kind: 'threeD' }),
    '3ds': nonMedia('3ds', { kind: 'threeD' }),
    ply: nonMedia('ply', { kind: 'threeD' }),
    off: nonMedia('off', { kind: 'threeD' }),
    glb: nonMedia('glb', { kind: 'threeD' }),
    gltf: nonMedia('gltf', { kind: 'threeD' }),
};
const getExtData = (ext) => {
    return (exports.EXT_DATA[ext.toLowerCase()] || {
        ext,
        type: types_1.ClipType.nonMedia,
        kind: 'other',
        transcodable: false,
    });
};
exports.getExtData = getExtData;
const getExtsForKind = (kind) => {
    return Object.values(exports.EXT_DATA)
        .filter((extData) => extData.kind === kind)
        .map(({ ext }) => ext);
};
exports.getExtsForKind = getExtsForKind;
const getExtsForType = (type) => {
    return Object.values(exports.EXT_DATA)
        .filter((extData) => extData.type === type)
        .map(({ ext }) => ext);
};
exports.getExtsForType = getExtsForType;
const getExtsMatching = (f) => {
    return Object.values(exports.EXT_DATA)
        .filter(f)
        .map(({ ext }) => ext);
};
exports.getExtsMatching = getExtsMatching;
//# sourceMappingURL=exts.js.map